import { Select } from "@shopify/polaris";
import { FieldRenderProps } from "react-final-form";
import { FC } from "react";


interface SelectedProductsFieldProps extends FieldRenderProps<any> {
}

const ActionField: FC<SelectedProductsFieldProps> = ({ input, options }) => {
  return (
    <Select
      label="Action"
      options={options}
      onChange={input.onChange}
      value={input.value}
    />
  );
};

export default ActionField;